<div class="container">
    <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width:100%"></table>

    <ng-template #countryCheckboxRef let-data="adtData" let-emitter="captureEvents">
        <app-country-checkbox [data]="data" (emitter)="emitter($event)"></app-country-checkbox>
    </ng-template>
</div>
